// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"5b6a6c3f","113":"323af97a","292":"00cb3506"}[chunkId] + ".chunk.css";
};